import { combineReducers } from 'redux';
import { awbsReducer } from './awbsReducer';
import { awbsExportReducer } from './awbsExportReducer';
import authReducer from './authReducer';
import notificationReducer from './notificationReducer';
import { destinationPortsReducer } from './destinationPortsReducer';
import { originPortsReducer } from './originPortsReducer';
import { cartReducer } from './cartReducer';
import { truckCartReducer } from './truckCartReducer';
import { fetchingReducer } from './fetchingReducer';
import { destinationGhaReducer } from './destinationGhaReducer';
import { originGhaReducer } from './originGhaReducer';
import { destinationPortReducer } from './destinationPortReducer';
import { originPortReducer } from './originPortReducer';
import userReducer from './userReducer';

import addServiceAndTariffReducer from './addServiceAndTariffReducer';
import pickupDateReducer from './pickupDateReducer';
import { ghaInfoReducer } from './ghaInfoReducer';
import { awbPartStatusesReducer } from './awbPartStatusesReducer';
import { orderReducer } from './orderReducer';
import { networkErrorModalReducer } from './networkErrorModalReducer';
import { termsAndConditionsModalReducer } from './termsAndConditionsModalReducer';
import { awbsGhaReducer } from './awbsGhaReducer';
import invoiceFwdBalanceReducer from './invoiceFwdReducer'; 
import { triggerReducer } from './managedExportRightSideReducer';
import { orderLockedReducer } from './orderLockedReducer';
import { errorModalReducer } from './errorModalReducer';
import { counterRequestReducer } from './counterRequestReducer';
import { manualEntryEditReducer } from './manualEntryEditReducer';
import { offlineRfsReducer } from './offlineEditReducer';
import { awbsOfflineReducer } from './awbsOfflineReducer';
import { addAwbsReducer } from './addAwbsOrderReducer';
import { driverQueueReducer } from './driverQueueReducer';
import { counterReducer } from './counterReducer';
import { userCounterReducer } from './userCounterReducer';
import { buttonStateReducer } from './buttonStateReducer';
import { driverWaitingReducer } from './waitingListReducer';
import { selectAwbReducer } from './selectAwbReducer';
import { airlinesCounterReducer } from './counterAirlinesReducer';
import walletFwdBalanceReducer from './walletFwdReducer';

export const rootReducer = combineReducers({
  awbs: awbsReducer,
  awbsExport: awbsExportReducer,
  awbsGha: awbsGhaReducer,
  awbPartStatuses: awbPartStatusesReducer,
  auth: authReducer,
  notification: notificationReducer,
  destinationPorts: destinationPortsReducer,
  originPorts: originPortsReducer,
  cart: cartReducer,
  truckCart: truckCartReducer,
  fetching: fetchingReducer,
  destinationPort: destinationPortReducer,
  originPort: originPortReducer,
  destinationGhaId: destinationGhaReducer,
  originGhaId: originGhaReducer,
  additionalService: addServiceAndTariffReducer,
  pickupDate: pickupDateReducer,
  user: userReducer,
  ghaInfo: ghaInfoReducer,
  order: orderReducer,
  networkErrorModal: networkErrorModalReducer,
  termsAndConditionsModal: termsAndConditionsModalReducer,
  fwdBalance: invoiceFwdBalanceReducer,
  eWalletBalance: walletFwdBalanceReducer,
  updateManagedExportRightSideContainer: triggerReducer,
  orderLockedNumber: orderLockedReducer,
  errorModal: errorModalReducer,
  countersRequest: counterRequestReducer,
  manualEntryEdit: manualEntryEditReducer,
  manualEntryAdd: addAwbsReducer,
  offlineRfs: offlineRfsReducer,
  awbsOffline: awbsOfflineReducer,
  driverQueue: driverQueueReducer,
  countersAvailable: counterReducer,
  userCounter: userCounterReducer,
  buttonState: buttonStateReducer,
  driverReducer: driverWaitingReducer,
  selectAwb: selectAwbReducer,
  counterAirlines: airlinesCounterReducer
});
